import { DefaultButton, Panel, PanelType, Stack } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import '../../css/immocom.css';
import { DetailsListAPIParametre } from '../List/DetailsListAPIParametre';

/*
******************************************************************************************************
PROPS :
    ATTRIBUTS :
        int?    idAPI                       id de l'API pour laquelle on souhaite afficher les paramètres
        bool    isOpen                      détermine si panel ouvert ou non
    METHODES :
        void    onDismiss                   méthode appelée lorsque l'utilisateur clique sur "Annuler"
******************************************************************************************************
*/

export class FicheAPIParametres extends Component {

    static defaultProps = {
        isOpen: false,
        onDismiss: () => null
    };

    _onRenderFooterContent = () => <Stack horizontal>
        <DefaultButton onClick={this.props.onDismiss}>Fermer</DefaultButton>
    </Stack>;

    render = () => {

        const { idAPI, isOpen, onDismiss } = this.props;
        return <Panel
            closeButtonAriaLabel="Fermer"
            headerText={"Paramètres de l'API"}
            isOpen={isOpen}
            onDismiss={onDismiss}
            onRenderFooterContent={this._onRenderFooterContent}
            styles={{ content: { height: "100%" } }}
            type={PanelType.large}
        >
            <DetailsListAPIParametre idAPI={idAPI} />
        </Panel>;

    };

};